import Tabs from '../util/tabs';
import Dropdown from '../util/dropdown';

class CustomerSuccess {
  constructor(el) {
    this.el = el;
    this.mobileNavigation = this.el.querySelector('[data-mobile-navigation]');
    this.elTabsContainer = this.el.querySelector('[data-tabs-container]');
    this.dropdown = this.el.querySelector('[data-dropdown]');
    this.onClick = this.onClick.bind(this);
    this.activeOption = null;
    this.init();
  }

  init() {
    this.mobileInitialNavigation();
    this.initTabs();
  }

  initTabs() {
    const tabs = this.el.querySelector('.tabs');
    this.tabs = new Tabs({
      el: tabs,
    });
  }

  initDropdown() {
    new Dropdown({
      el: this.dropdown,
      activeOption: this.activeOption,
      onChange: (target) => {
        this.tabs.changeTab({ currentTarget: target });
      },
    });
  }

  mobileInitialNavigation() {
    const btns = this.mobileNavigation.querySelectorAll('.btn');
    Array.from(btns).forEach((button) => {
      button.addEventListener('click', () => this.onClick(button));
    });
  }

  onClick(button) {
    this.activeOption = button.dataset.id;
    this.tabs.changeTab({ currentTarget: button });
    this.mobileNavigation.classList.add('hidden');
    this.dropdown.classList.add('visible');
    this.elTabsContainer.classList.add('visible');

    requestAnimationFrame(() => this.initDropdown());
  }
}

export default CustomerSuccess;
